import lodash from "lodash";

export const createOnSearch = ({ data, debounceReloadItems }) => {
    return (value) => {
        data.isLoading = true;
        data.searchQuery = value;
        debounceReloadItems();
    };
};

export const createReloadItems = ({ data, props }) => {
    return () => {
        data.isLoading = true;
        const result = props.list({ searchQuery: data.searchQuery });
        if (result instanceof Promise) {
            result.then((items) => {
                data.items = items;
                data.isLoading = false;
            });
        } else {
            data.items = result;
            data.isLoading = false;
        }
    };
};

export const createOnUpdateValue = ({ data, props, emit }) => {
    return (value) => {
        data.searchQuery = "";
        if (!props.mode) {
            if (value) {
                value = getItems({ data, props }).find((d) => value === getKeyValue({ record: d, props }));
            }
            emit("update:value", lodash.cloneDeep(value));
        }
    };
};

export const createOnSelect = ({ data, props, emit }) => {
    return (value) => {
        if (props.mode) {
            if (value) {
                value = getItems({ data, props }).find((d) => value === getKeyValue({ record: d, props }));
            }
            value = lodash.cloneDeep(value);
            props.value.push(value);
            if (props.selectWithIsSave) {
                value.isSave = true;
            }
            emit("select", lodash.cloneDeep(value));
            emit("update:value", props.value);
        }
    };
};

export const createOnSelectAll = ({ data, props, onSelect }) => {
    return () => {
        if (props.mode) {
            const selectIds = getValues({ props });
            getItems({ data, props })
                .map((d) => getKeyValue({ record: d, props }))
                .filter((value) => !selectIds.includes(value))
                .forEach((value) => onSelect(value));
        }
    };
};

export const createOnDeselect = ({ props, emit }) => {
    return (value) => {
        if (props.mode) {
            if (value) {
                value = props.value.find((d) => value === getKeyValue({ record: d, props }));
            }
            const index = props.value.findIndex(
                (d) => d.isDelete !== true && getKeyValue({ record: d, props }) === getKeyValue({ record: value, props })
            );
            if (index !== -1) {
                if (props.value[index].id) {
                    props.value[index].isDelete = true;
                } else {
                    props.value.splice(index, 1);
                }
            }
            emit("deselect", lodash.cloneDeep(value));
            emit("update:value", props.value);
        }
    };
};

export const createOnDeselectAll = ({ data, props, onDeselect }) => {
    return () => {
        if (props.mode) {
            const selectIds = getValues({ props });
            getItems({ data, props })
                .map((d) => getKeyValue({ record: d, props }))
                .filter((value) => selectIds.includes(value))
                .forEach((value) => onDeselect(value));
        }
    };
};

export const createOnDropdownVisibleChange = ({ data, onSearch, reloadItems }) => {
    return (open) => {
        data.open = open;
        if (open && data.isOpenFirst) {
            data.isOpenFirst = false;
            onSearch();
        } else if (open) {
            reloadItems();
        }
    };
};

export const getValues = ({ props }) => {
    if (!props.mode) {
        return getKeyValue({ record: props.value, props });
    }
    return props.value.filter((d) => d.isDelete !== true).map((d) => getKeyValue({ record: d, props }));
};

export const getItems = ({ data, props }) => {
    if (!data.open) {
        if (!props.mode) {
            if (props.value) {
                return [props.value];
            }
        } else {
            return props.value.filter((d) => d.isDelete !== true);
        }
    }
    return data.items;
};

export const getKeyValue = ({ record, props }) => {
    if (!record) {
        return null;
    }
    if (props.rowKey) {
        return props.rowKey({ record });
    }
    if (props.optKey) {
        return lodash.get(record, props.optKey);
    }
    return record;
};
